import Api from "./Api";

const endpoint = "/maintenance";
export default {
    postAdminMessage(data) {
        return Api.postData(endpoint + "/admin_message", data);
    }
};
